interface ICanHasWarning {
  warn: (str) => void;
}

let logger: { warn: (str) => void } = console;

export function warn(message: string): void {
  if (logger) {
    logger.warn(message);
  }
}

export function setLogger(newLogger: ICanHasWarning): void {
  logger = newLogger;
}
